import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@avtechsoftware/react-component-library/src/components/common/Icon/Icon';
import TimePeriodTypeSelect from './TimePeriodTypeSelect/TimePeriodTypeSelect';
import TimePartSelect from './TimePartSelect/TimePartSelect';
import { TIME_SELECTOR_HOURS, TIME_SELECTOR_MINUTES } from '../../../../../hooks/useQuietTimes/useQuietTimes';
import timePeriodPropType from '../../../../../../utility/PropTypes/quietTimeScheduleTimePeriodPropType';
import * as TimePeriodTypes from '../../../../../../utility/types/TimePeriodTypes';

function TimePeriodFormGroup({
  currentTimePeriod, handleUpdateTimePeriod, timePeriodRowIndex, handleDeleteTimePeriod,
}) {
  const handleTimePeriodTypeChange = (periodBoundary, event) => {
    const updatedTimePeriodTypeId = parseInt(event.target.value, 10);

    if (TimePeriodTypes.isGlobalTimePeriodType(updatedTimePeriodTypeId)) {
      handleUpdateTimePeriod({
        ...currentTimePeriod,
        startTimePeriodTypeId: updatedTimePeriodTypeId,
        endTimePeriodTypeId: updatedTimePeriodTypeId,
      },
      timePeriodRowIndex);
    } else {
      handleUpdateTimePeriod({
        ...currentTimePeriod,
        [`${periodBoundary}TimePeriodTypeId`]: updatedTimePeriodTypeId,
      },
      timePeriodRowIndex);
    }
  };

  const handleTimePartChange = (periodBoundary, timeUnit, event) => {
    const updatedTimePartValue = parseInt(event.target.value, 10);
    handleUpdateTimePeriod({
      ...currentTimePeriod,
      [periodBoundary + timeUnit]: updatedTimePartValue,
    },
    timePeriodRowIndex);
  };

  return (
    <div className="form-inline mb-2">
      <div className="d-flex align-items-center">
        <TimePeriodTypeSelect
          onTimePeriodTypeChange={(e) => handleTimePeriodTypeChange('start', e)}
          timePeriodTypeId={currentTimePeriod.startTimePeriodTypeId}
          disabled={false}
        />
        <div className="mx-1" />
        <TimePartSelect periodBoundary="start" timeUnit={TIME_SELECTOR_HOURS} currentBoundaryTimePart={currentTimePeriod.startHours} onTimePeriodChange={handleTimePartChange} />
        <div className="mx-1">:</div>
        <TimePartSelect periodBoundary="start" timeUnit={TIME_SELECTOR_MINUTES} currentBoundaryTimePart={currentTimePeriod.startMinutes} onTimePeriodChange={handleTimePartChange} />
        <div className="text-center mx-2">
          to
        </div>
      </div>
      <div className="d-flex align-items-center">
        <TimePeriodTypeSelect
          onTimePeriodTypeChange={(e) => handleTimePeriodTypeChange('end', e)}
          timePeriodTypeId={currentTimePeriod.endTimePeriodTypeId}
          disabled={TimePeriodTypes.isGlobalTimePeriodType(currentTimePeriod.startTimePeriodTypeId)}
        />
        <div className="mx-1" />
        <TimePartSelect periodBoundary="end" timeUnit={TIME_SELECTOR_HOURS} currentBoundaryTimePart={currentTimePeriod.endHours} onTimePeriodChange={handleTimePartChange} />
        <div className="mx-1">:</div>
        <TimePartSelect periodBoundary="end" timeUnit={TIME_SELECTOR_MINUTES} currentBoundaryTimePart={currentTimePeriod.endMinutes} onTimePeriodChange={handleTimePartChange} />
        <div className="form-control-static">
          <button type="button" className="btn btn-sm" aria-label="remove time period" onClick={() => handleDeleteTimePeriod(timePeriodRowIndex)}>
            <Icon className="text-muted" icon="circle-minus" />
          </button>
        </div>
      </div>
    </div>
  );
}
TimePeriodFormGroup.propTypes = {
  currentTimePeriod: PropTypes.shape(timePeriodPropType).isRequired,
  timePeriodRowIndex: PropTypes.number.isRequired,
  handleUpdateTimePeriod: PropTypes.func.isRequired,
  handleDeleteTimePeriod: PropTypes.func.isRequired,
};
export default TimePeriodFormGroup;
